import { IValidationNotificator } from "../Notificators/IValidationNotificator";
import { INotificator } from "../Notificators/INotificator";
import { ValidationResult, ValidationError } from "../../../Scripts/i4U/Validation/Models"

if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}

export interface IValidationFailureHandler
{
    handleErrors(errors: object): void
    handle(result: ValidationResult): void

    setValidationNotificator(validationNotificator: IValidationNotificator);
    getValidationNotificator(): IValidationNotificator;

    setNotificator(notificator: INotificator);
    getNotificator(): INotificator;

    setSettings(settings: IValidationFailureHandlerSettings): void;
    getSettings(): IValidationFailureHandlerSettings;
}

export enum FindMode {

    None = 0,
    ID = 1,
    Name = 2,
    FirstIDThenName = 3
}

export enum FindResultMode
{
    None = 0,
    FirstOrDefault = 1,
    Multiple = 2,
    SingleOrDefault = 3,
    Single = 4
}

export interface IValidationFailureHandlerSettings
{
    FindMode: FindMode;
    FindResultMode: FindResultMode; 
}

export class DefaultValidationFailureHandlerSettings implements IValidationFailureHandlerSettings
{
    FindMode: FindMode;
    FindResultMode: FindResultMode;

    constructor(findMode: FindMode = FindMode.ID, findResultMode: FindResultMode = FindResultMode.FirstOrDefault)
    {
        this.FindMode = findMode;
        this.FindResultMode = findResultMode;
    }
}

export class HandlerValidationError implements ValidationError
{
    Identifier: string;
    LocalizedMessage: string;

    constructor(Identifier, LocalizedMessage)
    {
        this.Identifier = Identifier;
        this.LocalizedMessage = LocalizedMessage;
    }
}

export class DefaultValidationFailureHandler implements IValidationFailureHandler
{
    private ValidationNotificator: IValidationNotificator;
    private Notificator: INotificator;

    private Settings: IValidationFailureHandlerSettings;

    constructor(validationNotificator: IValidationNotificator, notificator: INotificator = null, settings: IValidationFailureHandlerSettings = null)
    {
        this.ValidationNotificator = validationNotificator;
        this.Notificator = notificator;

        if (settings == null)
        {
            settings = new DefaultValidationFailureHandlerSettings();
        }
        this.Settings = settings;
    }

    handle(result: ValidationResult): void
    {
        if (result.Failed)
        {
            this.handleValidationErrors(result.Errors);
        }
        else if (result.Ok)
        {
            if (this.Notificator != null)
            {
                //this.notificator.showSuccessMessage("success");
            }
        }
        else
        {
            console.error("this should not happen");
        }
    }


    handleErrors(errors: object): void {
        console.log(errors);
        if (this.isElementObject(errors)) {
            let temp = Object.entries(errors);
            let validationErrors: HandlerValidationError[] = [];
            for (const [key, value] of temp) {
                let ve = new HandlerValidationError(key, value);
                validationErrors.push(ve);
            }
            console.log(validationErrors);
            this.handleValidationErrors(validationErrors);
        }
        else if (Array.isArray(errors)) {
            //TODO: Logic to make errors from these
            console.log("array");
        }

        //this.validationNotificator.addValidationError("")
    }

    setValidationNotificator(validationNotificator: IValidationNotificator) {
        this.ValidationNotificator = validationNotificator;
    }
    getValidationNotificator(): IValidationNotificator {
        return this.ValidationNotificator;
    }
    setNotificator(notificator: INotificator) {
        this.Notificator = notificator;
    }
    getNotificator(): INotificator {
        return this.Notificator;
    }

    setSettings(settings: IValidationFailureHandlerSettings): void {
        this.Settings = settings;
    }
    getSettings(): IValidationFailureHandlerSettings {
        return this.Settings;
    }

    private handleValidationErrors(errors: ValidationError[])
    {
        for (var i = 0; i < errors.length; i++) {
            let e = errors[i]
            this.handlevalidationError(e);
        }
    }

    private handlevalidationError(error: ValidationError): void
    {
        switch (this.Settings.FindMode)
        {
            case FindMode.None:
                break;
            case FindMode.Name:
                    this.handleNameError(error);
                break;
            case FindMode.FirstIDThenName:
                let element = document.getElementById(error.Identifier);
                if (element == null || element == undefined)
                {
                    this.handleNameError(error);
                }
                else
                {
                    this.handleIdError(error);
                }
                break;
            case FindMode.ID:
            default:
                this.handleIdError(error);
                break;
        }
    }

    private handleNameError(error: ValidationError)
    {
        let elements = document.getElementsByName(error.Identifier);
        let results = this.GetResults(elements);
        if (results != null && results != undefined)
        {
            this.handleElementValidation(results, error.LocalizedMessage);
        }
        else
        {
            if (this.Notificator != null) {
                this.Notificator.showWarningMessage(error.LocalizedMessage);
            }
        }
        
    }

    private handleIdError(error: ValidationError)
    {
        let element = document.getElementById(error.Identifier);
        let result = this.GetResult(element);
        if (result != null && result != undefined)
        {
            let elems = new Array<HTMLElement>();
            elems[0] = result;
            this.handleElementValidation(elems, error.LocalizedMessage);
        }
        else
        {
            if (this.Notificator != null) {
                this.Notificator.showWarningMessage(error.LocalizedMessage);
            }
        }
    }

    private GetResult(element: HTMLElement): HTMLElement
    {
        switch (this.Settings.FindResultMode)
        {
            case FindResultMode.None:
                return null;
                break;
            case FindResultMode.Single://this could be used with unittests
                if (element == null || element == undefined)
                {
                    throw `Unsupported element: ${element} with FindResultMode: ${this.Settings.FindResultMode}`;
                }
                return element;
                break;
            case FindResultMode.FirstOrDefault:
            case FindResultMode.Multiple:
            case FindResultMode.SingleOrDefault:
            default:
                return element;
                break;
        }
    }

    private GetResults(elements: NodeListOf<HTMLElement>): Array<HTMLElement>
    {
        let result: Array<HTMLElement> = new Array<HTMLElement>();


        switch (this.Settings.FindResultMode) {
            case FindResultMode.None:
                result = null;
                break;
            case FindResultMode.Multiple:
                result = Array.from(elements);
                break;
            case FindResultMode.SingleOrDefault://this can be used for unittests
                if (elements == null || elements == undefined)
                {
                    result = null;
                }
                else
                {
                    if (elements.length > 1)
                    {
                        throw `Unsupported count of elements: ${elements} with FindResultMode: ${this.Settings.FindResultMode}`;
                    }
                    else
                    {
                        result[0] = elements[0];

                    }
                }  
                break;
            case FindResultMode.Single:
                if (elements == null || elements == undefined || elements.length != 1) {
                    throw `Unsupported count of elements: ${elements} with FindResultMode: ${this.Settings.FindResultMode}`;
                }
                else
                {
                    result[0] = elements[0];
                }
                break;
            case FindResultMode.FirstOrDefault:     
            default:
                if (elements != null && elements != undefined && elements[0] != undefined)
                {
                    result[0] = elements[0];
                }
                else
                {
                    result = null;
                }   
                break;
        }

        return result;
    }

    private handleElementValidation(elements: Array<HTMLElement>, msg: string)
    {
        if (elements != null && elements != undefined)
        {
            for (var i = 0; i < elements.length; i++) {
                let element = elements[i];
                if (element != undefined && element != null) {
                    this.ValidationNotificator.addValidationError(element, msg);
                }
            }
        }
    }

    private isElementObject(element) {
        return typeof element !== "undefined" && element != null && typeof element == "object";
    }
}